export default "__VITE_ASSET__tNJ4QO9$__"